<template>
  <div class="chart-container">
    <canvas ref="canvas" class="canvas-graph"></canvas>
  </div>
</template>

<script>
import { Line, Bar } from "vue-chartjs";

import ChartSettings from "./chart.settings.js";

import ChartDataLabels from "chartjs-plugin-datalabels";

Chart.defaults.global.legend.display = false;

import moment from 'moment'

export default {
  extends: Bar,
  data() {
    return {
      labels: [],
      collections: [],
    };
  },
  props: {
    datasets: Array,
    cafes: Array,
    colors: Array
  },
  watch: {
    datasets() {
      this.rerender();
    }
  },
  methods: {
    createChartData() {
      const first_dataset = this.datasets[this.cafes[0]._id];

      if (first_dataset.length <= 14) {
        this.labels = first_dataset.map(d => moment(d.timestamp, 'DD.MM.YYYY').format('ddd'));
      } else {
        this.labels = first_dataset.map(d => d.timestamp);
      }
    
    },
    makeChartDataset(color, data) {
      return {
        data,
        backgroundColor: color,
        pointBorderColor: "rgba(0, 0, 0, 0)",
        pointBackgroundColor: "rgba(0, 0, 0, 0)",
        pointHoverBackgroundColor: color,
        pointHoverBorderColor: color,
        lineTension: 0,
        fill: true,
        borderColor: "rgba(0,0,0,0)"
      }
    },
    makeBarDataset(color, data) {
      return {
        data,
        backgroundColor: color,
        hoverBackgroundColor: color
      }
    },
    rerender() {
      this.createChartData();
      this.renderChart(
      {
        labels: this.labels,
        datasets: Object.values(this.datasets).map((d,i) => {
          return this.makeBarDataset(
            this.colors[i % this.colors.length],
            d.map(a => a.income)
          );
        })
      },

      {
        scales: ChartSettings.scales,
      }
    );
    }
  },
  mounted() {
    this.addPlugin(ChartDataLabels);

    this.rerender();
  }
};
</script>

<style scoped>
.canvas-graph {
  background: #1d1d1b;
  padding-top: 5vh;
  width: 75vh !important;
  height: 50vh !important;
  border-radius: 0 0 1vh 1vh;
}

.chart-container {
  width: min-content;

  display: block;
}
</style>